import ReducerRegistry from '../base/redux/ReducerRegistry';
import { SET_E2EE_ENABLE_ON_CREDENTIAL_READY, SET_E2EE_ROOM_OWNER, SET_MAX_MODE, TOGGLE_E2EE } from './actionTypes';
import { MAX_MODE } from './constants';
const DEFAULT_STATE = {
    e2eeRoomOwnerId: undefined,
    enableOnCredentialReady: false,
    enabled: false,
    maxMode: MAX_MODE.DISABLED
};
/**
 * Reduces the Redux actions of the feature features/e2ee.
 */
ReducerRegistry.register('features/e2ee', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case TOGGLE_E2EE:
            return {
                ...state,
                enableOnCredentialReady: false,
                enabled: action.enabled
            };
        case SET_E2EE_ENABLE_ON_CREDENTIAL_READY:
            return {
                ...state,
                enableOnCredentialReady: action.enabled
            };
        case SET_MAX_MODE: {
            return {
                ...state,
                maxMode: action.maxMode
            };
        }
        case SET_E2EE_ROOM_OWNER: {
            return {
                ...state,
                e2eeRoomOwnerId: action.ownerId
            };
        }
        default:
            return state;
    }
});
